module.exports = {
          srcSet: __webpack_public_path__ + "public/images/b102f77b905ff03d7775f5d2e90f53e5-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/b102f77b905ff03d7775f5d2e90f53e5-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/b102f77b905ff03d7775f5d2e90f53e5-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/b102f77b905ff03d7775f5d2e90f53e5-1774.webp"},
          
          width: 1774,
          height: 887
        }